import { bemClassNames } from "@multiweb/reactUtils";

export const classNames = bemClassNames("grid-participants-component");
/**
 * Hodnota se použije pro zobrazení skeletonů.
 */
export const DEFAULT_DATA_COUNT_TO_LOAD = 8;

/**
 * Odhad výšky řádku, používá se pro VirtualilizedList.
 */
export const ESTIMATED_ROW_HEIGHT = 50;
